import axios, { AxiosResponse } from 'axios';
import { AppConfig } from '../../../k1-portal-api/src/config/appConfig';

const config = {} as AppConfig;

const normalizeBasePath = (basePath?: string): string => {
  if (!basePath) {
    return '';
  }

  const trimmedBasePath = basePath.trim();
  if (!trimmedBasePath || trimmedBasePath === '/') {
    return '';
  }

  return `/${trimmedBasePath.replace(/^\/+|\/+$/g, '')}`;
};

const isLocalBrowserHost = (): boolean => {
  return (
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1'
  );
};

const getConfigHost = (): string => {
  if (isLocalBrowserHost()) {
    return 'http://localhost:7071';
  }

  return `${window.location.origin}${normalizeBasePath(process.env.REACT_APP_BASE_PATH)}`;
};

export const loadConfig = async (): Promise<AppConfig> => {
  const host = getConfigHost();

  // retrying to fetch the config multiple times,
  // otherwise site will not load on app start if the client builds faster than the api
  const response = await new Promise<AxiosResponse<AppConfig>>(
    async (resolve) => {
      let retries = 0;
      let success = false;
      const maxRetries = 5;

      while (!success) {
        try {
          const response = await axios.get<AppConfig>(`${host}/api/config`);
          success = true;
          resolve(response);
        } catch (err: any) {
          if (retries >= maxRetries) {
            throw err;
          }
          const status = err?.response?.status || 500;
          console.log(`Error getting config: ${status}. Trying again...`);

          // wait 5 seconds
          await new Promise((_) => setTimeout(_, 5000));
          retries++;
        }
      }
    },
  );

  Object.assign(config, response.data);
  Object.freeze(config);

  return config;
};

export const getConfig = (): AppConfig => config;
